"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockWaypoint = void 0;
const waterbody_1 = require("./waterbody");
function mockWaypoint(overrides = {}) {
    return {
        air_temperature_f: 0,
        barometer_in_hg: 0,
        barometer_trend: 'steady',
        cloud_cover_percent: 0,
        comments: 'mock_comments',
        conditions_saved: true,
        created_at: '2024-02-14T19:53:23.598Z',
        icon: 'sunny.png',
        id_hash: 'mock_id_hash',
        id: 123,
        img: 'mock_img.jpg',
        image_dimensions: {
            width: 400,
            height: 600,
            portrait: true,
            landscape: false,
        },
        lat: 45,
        lng: -90,
        moon_percent: 0,
        moon_phase: 'new moon',
        moon_overhead_at: '2024-05-06T12:00:00.000-05:00',
        moon_underfoot_at: '2024-05-06T00:00:00.000-05:00',
        moonrise: '2024-05-06T04:53:00.000-05:00',
        moonset: '2024-05-06T18:53:00.000-05:00',
        name: 'mock_name',
        outing_at: '2024-02-14T19:53:23.598Z',
        precipitation_percent: 10,
        public: false,
        sunrise: '2024-05-06T05:49:14.000-05:00',
        sunset: '2024-05-06T20:13:41.000-05:00',
        symbol_imported: null,
        timezone: 'America/Chicago',
        updated_at: '2024-02-14T19:53:23.598Z',
        water_clarity: 0,
        water_depth_ft: 0,
        water_temperature_f: 0,
        waterbody: (0, waterbody_1.mockWaterbody)(),
        waypoint_type: 'marker',
        weather_name: 'Sunny',
        wind_direction: 90,
        wind_mph: 0,
        ...overrides,
    };
}
exports.mockWaypoint = mockWaypoint;
